import { render, staticRenderFns } from "./BalanceGT.vue?vue&type=template&id=f43bd9fe&scoped=true&"
import script from "./BalanceGT.vue?vue&type=script&lang=ts&"
export * from "./BalanceGT.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43bd9fe",
  null
  
)

export default component.exports